export const introScale = [
  {
    label: '← Too few',
    n: 3,
    title: 'Too little stimulation',
    body: 'Fewer oocytes may be available for retrieval.',
    tint: 'bg-under-tint',
    text: 'text-under',
  },
  {
    label: 'Target response',
    n: 11,
    title: 'Balanced response',
    body: 'An adequate ovarian response for that patient.',
    tint: 'bg-target-tint',
    text: 'text-target',
  },
  {
    label: 'Too many →',
    n: 28,
    title: 'Excessive follicular response',
    body: 'Higher risk of OHSS and preventive intervention.',
    tint: 'bg-over-tint',
    text: 'text-over',
  },
];
